import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import {PaymentIntent} from "../../model/PaymentIntent";
import {OrderDetails} from "../../model/OrderDetails";

@Injectable({ providedIn: 'root' })
export class PaymentService {
    constructor(private http: HttpClient) {}
    private apiUrl = '/api/payments'; // dein Spring Boot Backend
    // nur das PaymentIntent vom Backend holen
    // async createPaymentIntent(amount: number): Promise<any> {
    //     const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    //     return await firstValueFrom(
    //         this.http.post('/api/payment/create-payment-intent', { amount }, { headers })
    //     );
    // }


    createPaymentIntent(orderDetails: OrderDetails) {
        return this.http.post<any>(`${this.apiUrl}/create-payment-intent`, orderDetails).toPromise();
    }

    createTopupIntent(amount: number) {
        return this.http.post<any>(`${this.apiUrl}/create-topup-intent`, { amount }).toPromise();
    }

    createSubscription(payload: any, paymentMethodId: string) {
        //return this.http.post<any>(`${this.apiUrl}/create-subscription`, { email, paymentMethodId }).toPromise();
        return this.http.post<any>(`${this.apiUrl}/create-subscription`, payload);
    }

    checkPaymentInBackend(paymentIntent: PaymentIntent) {
        return this.http.post<any>(`${this.apiUrl}/verify`, paymentIntent);
    }
    checkCreditInBackend(paymentIntent: PaymentIntent) {
        return this.http.post<any>(`${this.apiUrl}/verify/credit`, paymentIntent);
    }
}
//pk_test_51RvEPZDDL4kNOlHQpWD2sjxfSYmTwmGkAdXGKoyruYWkkzsBNzWYj9EUDU3DccY9vA1JNHCAGBpJlFLHwCXKwbZo00tFHhRhKX
